<template>
  <div role="radiogroup">
    <label v-for="(option, index) in normalizedOptions" :key="`${option.value}-${index}`" class="custom-control custom-radio custom-control-inline">
      <input type="radio" class="custom-control-input" :name="name" :value="option.value" :checked="currentValue === option.value" @change="select(option.value)" />
      <span class="custom-control-label">{{ option.text }}</span>
    </label>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'BFormRadioGroup',
  props: {
    modelValue: { default: undefined },
    value: { default: undefined },
    options: { type: Array, default: () => [] },
    name: { type: String, default: '' }
  },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const currentValue = computed(() => props.modelValue ?? props.value)
    const normalizedOptions = computed(() => props.options.map((option: any) =>
      typeof option === 'object' ? option : { text: String(option), value: option }
    ))
    const select = (value: unknown) => {
      emit('update:modelValue', value)
      emit('input', value)
      emit('change', value)
    }
    return { currentValue, normalizedOptions, select }
  }
})
</script>
